/**
 * Pre-paint stamps on <html>, the body not being parsed yet: each decides how
 * the first frame is painted, so a deferred read would land as a flash. Loaded
 * synchronously from the head, like bq-sb-right.js.
 */
(function () {
  'use strict';

  var me = document.currentScript;
  var doc = document.documentElement;
  if (window.bqPrepaint) return; // a second run would read back its own session stamps
  window.bqPrepaint = true;

  /* Tasks waiting for their element; a task returns true once it is done. */
  var pending = [];
  function sweep() {
    pending = pending.filter(function (task) { return !task(); });
    if (pending.length && document.readyState === 'loading') requestAnimationFrame(sweep);
  }

  /* Topbar: html.bq-topbar-replay says the entrance already played this session,
     View Transitions selling a persistent page that a replayed rise would break. */
  try {
    if (sessionStorage.getItem('bq_topbar_played')) doc.classList.add('bq-topbar-replay');
    else sessionStorage.setItem('bq_topbar_played', '1');
  } catch (e) {}

  /* Home: a draw written in Liquid is frozen for the life of Shopify's page
     cache, so the rank is drawn here and stamped on the root for CSS to read. */
  pending.push(function () {
    const hero = document.querySelector('[data-bq-plates]');
    if (!hero) return document.readyState !== 'loading';
    const sets = hero.getAttribute('data-bq-plates').split('|');
    const rank = Math.floor(Math.random() * sets.length);
    doc.setAttribute('data-bq-plate', rank);
    // Preload only the plate about to be shown; srcset and sizes are the tag's
    // own, so this never doubles the fetch.
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.setAttribute('fetchpriority', 'high');
    link.setAttribute('imagesrcset', sets[rank]);
    link.setAttribute('imagesizes', hero.getAttribute('data-bq-plate-sizes') || '');
    document.head.appendChild(link);
    return true;
  });

  pending.push(function () {
    const grid = document.querySelector('[data-bq-cats]');
    if (!grid) return document.readyState !== 'loading';
    const cards = parseInt(grid.getAttribute('data-bq-cats'), 10) || 0;
    for (let card = 1; card <= cards; card += 1) {
      doc.classList.add('bq-cat' + card + '-' + Math.floor(Math.random() * 3));
    }
    doc.classList.add('bq-cat-on');
    return true;
  });

  /* Pick: the same trade for any section. A container declares how many
     candidates it holds and CSS reveals the child matching the stamped rank. */
  pending.push(function () {
    document.querySelectorAll('[data-bq-pick]').forEach(function (box) {
      if (box.hasAttribute('data-bq-picked')) return;
      box.setAttribute('data-bq-picked', '');
      const n = parseInt(box.getAttribute('data-bq-pick'), 10) || 1;
      box.classList.add('bq-pick-' + Math.floor(Math.random() * n));
    });
    return document.readyState !== 'loading';
  });

  /* Pre-home: html.bq-porte-on and the emerald canvas must land before the first
     frame, or the cream page shows through before the veil composites. */
  if (me && me.dataset.porte === '1') armPorte();

  function armPorte() {
    var reduced = false;
    try { reduced = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    var skip = reduced || document.referrer.indexOf(location.origin) === 0;
    try { skip = skip || sessionStorage.getItem('bq_preaccueil_vue') === '1'; } catch (e) {}

    if (skip) {
      pending.push(function () {
        var veil = document.getElementById('BqPorte');
        if (!veil) return document.readyState !== 'loading';
        veil.parentNode.removeChild(veil); // never shown: .bq-porte is hidden without bq-porte-on
        return true;
      });
      return;
    }

    try { sessionStorage.setItem('bq_preaccueil_vue', '1'); } catch (e) {}

    // The medallion is the veil's only network file and is due 0.06s into the
    // bloom, too soon to wait for the SVG to be parsed on a cold cache.
    if (me.dataset.medaillon) {
      document.head.appendChild(Object.assign(document.createElement('link'), {
        rel: 'preload', as: 'image', fetchPriority: 'high', href: me.dataset.medaillon
      }));
    }

    // Emerald root canvas before first paint, the default being cream; restored
    // on open by bq-pre-accueil.js, or by the safety net below.
    var prevBg = doc.style.background;
    doc.style.background = '#132a1f';
    doc.classList.add('bq-porte-on');

    // Low-end devices: drop the ornaments (glow, unfolding, breathing).
    var lite = false;
    try {
      lite = (navigator.deviceMemory && navigator.deviceMemory <= 4) ||
             (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
             (navigator.connection && navigator.connection.saveData === true) || false;
    } catch (e) {}

    pending.push(function () {
      var veil = document.getElementById('BqPorte');
      if (veil) { wirePorte(veil, lite, prevBg); return true; }
      if (document.readyState === 'loading') return false;
      // Parsed without its veil (a stripped template): undo the canvas, or the
      // page stays emerald.
      doc.style.background = prevBg;
      doc.classList.remove('bq-porte-on');
      return true;
    });
  }

  /* is-on, bq-lite and _bq stay on the veil for bq-pre-accueil.js, which being
     deferred runs before DOMContentLoaded. */
  function wirePorte(veil, lite, prevBg) {
    if (lite) veil.classList.add('bq-lite');
    veil._bq = { lite: lite, prevBg: prevBg, bloomAt: null };
    veil.classList.add('is-on');

    // Released once two consecutive frames prove the compositor is keeping up; a
    // forced release means it never did, so the ornaments are dropped there.
    var started = false, good = 0, last = 0, deadline = 0;
    function release(force) {
      if (started) return;
      started = true;
      if (force && good < 2 && !lite) { lite = true; veil._bq.lite = true; veil.classList.add('bq-lite'); }
      veil.classList.add('is-ready');
      veil._bq.bloomAt = Date.now();
      if (veil._bq.onBloom) veil._bq.onBloom();
    }
    function probe(now) {
      if (started) return;
      if (!deadline) { deadline = now + 450; last = now; requestAnimationFrame(probe); return; }
      var d = now - last;
      last = now;
      good = d <= 32 ? good + 1 : 0;
      if (good >= 2) release(false);
      else if (now >= deadline) release(true);
      else requestAnimationFrame(probe);
    }
    requestAnimationFrame(probe);

    // Safety net if the deferred orchestrator fails to load: reveal the site.
    setTimeout(function () {
      if (veil._orchestrated || !veil.parentNode) return;
      veil.parentNode.removeChild(veil);
      doc.style.background = prevBg;
      doc.classList.remove('bq-porte-on');
    }, 4000);
  }

  if (pending.length) {
    requestAnimationFrame(sweep);
    // rAF is throttled in a background tab and a document parsed inside one frame
    // never fires it in time, so readystatechange is the hook.
    document.addEventListener('readystatechange', sweep, { once: true });
  }
})();
